import { useEffect, useState } from "react";

import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

import { InputProps } from "./types";

const DIMENSION_REGEX = /^\d+(\.\d+)?(px|%|em|rem|vh|vw)$/;
const BARE_NUMBER = /^\d+(\.\d+)?$/;

const normalize = (v: string) => (BARE_NUMBER.test(v) ? `${v}px` : v);
const isValid = (v: string) => v === "" || DIMENSION_REGEX.test(normalize(v));

export const DimensionInput = ({ label, value, onChange }: InputProps) => {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const commit = (val: string) => {
    const normalized = normalize(val);
    if (isValid(val)) {
      onChange(normalized);
      setLocalValue(normalized);
    } else {
      setLocalValue(value);
    }
  };

  return (
    <Panel.TextField
      label={label}
      placeholder="e.g. 16px, 50%, 1.5em"
      value={localValue}
      onChange={(e) => setLocalValue(e.target.value)}
      onBlur={() => commit(localValue)}
      onKeyDown={(e) => {
        if (e.key === "Enter") commit(localValue);
      }}
      error={localValue !== "" && !isValid(localValue)}
      helperText={
        localValue !== "" && !isValid(localValue)
          ? "e.g. 16px, 50%, 1.5em"
          : undefined
      }
    />
  );
};
